import { alpha } from "@commonlibs";
import { css } from "styled-components";
import { getTypographyStyle } from "./util/getTypographyStyle";

export const TextInputStyles = css(
    ({ theme: { spacing, palette, borderRadius, border } }) => css`
        .FormControl {
            .TextInput {
                border: ${border.sm};
                border-radius: ${borderRadius};
                padding: ${spacing.all(4, 5)};
                height: 3.75rem;

                //Input / Textarea styles
                input,
                textarea {
                    height: unset;
                    ${getTypographyStyle("body2Regular")};
                    color: ${palette.components.input.color};
                    ::placeholder {
                        color: ${palette.components.input.placeholderColor};
                        ${getTypographyStyle("body2Light")};
                    }
                    font-size: 16px;
                }

                //Suffix/Icon styles
                .suffix,
                .Icon {
                    font-size: 1.25rem;
                }

                //Status styles
                &.Valid {
                    background-color: ${alpha(palette.status.success, 0.12)};
                }

                &.Invalid {
                    background-color: ${alpha(palette.status.error, 0.12)};
                }

                &.Readonly {
                    input {
                        ${getTypographyStyle("body2Strong")};
                    }
                }
            }
        }
        .CodeInput .TextInput {
            border: ${border.otp};
        }

        //Variant styles
        .FormControl.Filled {
            .TextInput {
                border: none;
            }
            .TextInput:not(.Disabled):not(.Valid):not(.Invalid) {
                background-color: ${alpha(palette.lavender, 0.48)};
                .Icon {
                    color: ${palette.primary};
                }
            }
        }
    `,
);
